import React, {useEffect, useState} from "react";
import {TextField, Typography} from "@material-ui/core";

function GameChat (props) {
    const [commentString, setCommentString] = useState("")

    const updateScroll = () => {
        const element = document.getElementById("chatScrollArea");
        if(element)
            element.scrollTop = element.scrollHeight;
    }

    useEffect(updateScroll, [])

    if (props.talking)
        setTimeout(() => {
            let elem = document.getElementById("commentString");
            if(elem)
                elem.focus()
        }, 2)
    else
        setTimeout(() => {
            let elem = document.getElementById("commentString");
            if(elem)
                elem.blur()
        }, 2)

    const rowRenderer = (message) => {
        const playerInfo = message.playerInfo
        const imgUrl = playerInfo.profileUrl()

        return (
            <div key={message.message.messageKey} className="chat-row">

                <div className={playerInfo.isMe ? "chat-user-my-img" : "chat-user-img"}>
                    <img src={imgUrl} alt="player"/>
                </div>

                <div className={playerInfo.isMe ? "chat-my-message" : "chat-message"}>
                    <Typography variant="h6">
                        {message.message.message}
                    </Typography>
                </div>

            </div>
        );
    };

    const _handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            if (commentString.length > 0) {
                props.sendMessage(commentString)
                setCommentString("")
            }
            e.target.blur()
        }
    }

    const inputFocus = () => {
        setCommentString(props.talkingStart)
        // this.props.imTalkin()
    }

    const inputBlur = () => {
        setCommentString("")
        props.imNotTalkin()
    }

    return (
        <>
            <div id="chatScrollArea" className="chatArea">
                {props.chatMessages.map(message => {
                    return rowRenderer(message)
                })}
            </div>
            <TextField
                className="Chat-area-small"
                id="commentString"
                name="commentString"
                label="Comment"
                variant="outlined"
                onClick={() => props.startTalking("")}
                disabled={!props.talking}
                onFocus={inputFocus}
                onBlur={inputBlur}
                value={commentString}
                onKeyDown={_handleKeyDown}
                onChange={(event) => setCommentString(event.target.value)}
            />
        </>
    )
}

export default GameChat
